/* eslint-disable @typescript-eslint/no-unused-vars */
import { ForwardedRef, forwardRef, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FaCrown } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'

import { TryPremiumModal } from '../../modals//TryPremiumModal'
import { ModalWrapper } from '../../modals/ModalWrapper'
import { use } from 'i18next'
import { getThemes } from '../../services/themes'

interface ThemesRadioGroupProps {
  subscription: string | null | undefined
}

export const ThemesRadioGroup = forwardRef(
  (
    { subscription }: ThemesRadioGroupProps,
    _ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const { t } = useTranslation()
    const { watch, setValue } = useFormContext<DesignFormFields>()
    const [showModal, setShowModal] = useState(false)
    const navigate = useNavigate()
    const [themes, setThemes] = useState<Theme[] | null>(null)

    const handleChange = (theme_id: number, isPremium: boolean) => {
      if (!subscription && isPremium) {
        setShowModal(true) // Show the modal if user doesn't have subscription
        return
      } else {
        setValue('theme_id', theme_id) // Select the radio button if user has subscription
      }
    }

    const getAllThemes = async () => {
      const themes = (await getThemes()) as Theme[]
      setThemes(themes)
    }

    useEffect(() => {
      getAllThemes()
    }, [])

    return (
      <>
        <div className="mb-12">
          <label className="mb-6 block text-[18px] font-medium">
            {t('theme')}
          </label>
          <div className="grid grid-cols-3 gap-3 sm:grid-cols-2 lg:grid-cols-6">
            {themes &&
              themes.map((theme, index) => (
                <div key={`theme-${theme.id}`}>
                  <label
                    htmlFor={`theme-${index}`}
                    className={`relative mx-auto mb-2 flex h-[150px] w-full max-w-[100px] cursor-pointer items-center justify-center rounded-md bg-gray-200   ${
                      +watch('theme_id') === theme.id
                        ? 'border border-blue-800'
                        : ''
                    }`}
                    onClick={() => handleChange(theme.id, theme.premium)}
                  >
                    <FaCrown
                      color="#ffcc00"
                      className={`absolute right-2 top-1.5 ${theme.premium ? 'opacity 1' : 'opacity-0'} pointer-events-none`}
                    />
                    {theme.previewImage && <img src={theme.previewImage} alt={theme.title} className='w-full h-full rounded-md' />}
                    <input
                      type="radio"
                      id={`theme-${index}`}
                      value={theme.id}
                      className="sr-only"
                    />
                  </label>
                  <p className="text-center">{theme.title}</p>
                </div>
              ))}
          </div>
        </div>

        <ModalWrapper showModal={showModal} onClose={() => setShowModal(false)}>
          <TryPremiumModal
            showModal={showModal}
            onClose={() => setShowModal(false)}
            onConfirm={() => {
              setShowModal(false)
              navigate('/pricing')
            }}
          />
        </ModalWrapper>
      </>
    )
  },
)
